exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes eb-icon--spin-data-v-54563ae8{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.eb-icon[data-v-54563ae8]{display:inline-flex;overflow:hidden}.eb-icon--spin[data-v-54563ae8]{animation:eb-icon--spin-data-v-54563ae8 2s linear infinite}.eb-icon--pulse[data-v-54563ae8]{animation:eb-icon--spin-data-v-54563ae8 2s steps(8) infinite}.eb-icon--slow[data-v-54563ae8]{animation-duration:3s}.eb-icon--fast[data-v-54563ae8]{animation-duration:1s}.eb-icon__content[data-v-54563ae8]{display:inline-block;height:inherit;width:inherit}", ""]);

// exports
